import { setLocalAuthToken } from "../../storage/localStorage";

export const loginHelper = (token: String | undefined) => {
  if (token) setLocalAuthToken(token);
};
